export function addSkipIntroButton(
  playerRef: any,
  skipIntroEndTime: any,
  skipIntroStartTime: any,
  analyticsManager: {
    reportEvent: (
      arg0: string,
      arg1: { introStartTime: any; introEndTime: any }
    ) => void;
  }
) {
  const videoPlayer = playerRef;
  const skipIntroContainer = document.createElement('DIV');
  skipIntroContainer.className = `skip_intro_container`;

  const skipIntroButton = document.createElement('DIV');
  skipIntroButton.className = 'skip_intro_button';
  skipIntroButton.innerHTML = 'SKIP INTRO';

  skipIntroContainer?.appendChild(skipIntroButton);

  document
    .getElementsByClassName('video-js')[0]
    ?.appendChild(skipIntroContainer);

  skipIntroButton.addEventListener('click', () => {
    const PlayState = document.getElementsByClassName('vjs-playing')[0];
    videoPlayer.pause();
    document
      .getElementsByClassName('video-js')[0]
      .removeChild(skipIntroContainer);
    videoPlayer.currentTime(skipIntroEndTime);
    PlayState ? videoPlayer.play() : videoPlayer.pause();
    const eventPayload = {
      introStartTime: skipIntroStartTime,
      introEndTime: skipIntroEndTime
    };
    analyticsManager.reportEvent('Skip Intro', eventPayload);
  });
}
